import {NgModule} from '@angular/core';
import {LocalDatePipe} from './local-date.pipe';
import {LanguageModule} from '../../language/language.module';

const MY_PIPES = [LocalDatePipe];

@NgModule({
  imports: [LanguageModule],
  declarations: [...MY_PIPES],
  exports: [...MY_PIPES],
  providers: [...MY_PIPES],
})
export class PipesModule {}
